import { findSearchBox } from '../../utils/common';
import { FluxTag } from '../tag';
import * as riot from 'riot';

export interface SubmitConfig {
  label?: string;
  staticSearch?: boolean;
}

export const DEFAULT_CONFIG: SubmitConfig = {
  label: 'Search',
  staticSearch: false
};

export interface Submit extends FluxTag<SubmitConfig> {
  root: riot.TagElement & { value: any };
}

export class Submit {

  searchBox: HTMLInputElement;

  init() {
    this.configure(DEFAULT_CONFIG);

    if (this.root.tagName === 'INPUT') {
      this.root.value = this._config.label;
    }

    this.on('mount', this.setSearchBox);
    this.root.addEventListener('click', this.submitQuery);
  }

  setSearchBox() {
    this.searchBox = findSearchBox();
  }

  submitQuery() {
    const inputValue = this.searchBox.value;

    if (this._config.staticSearch && this.services.url.active()) {
      this.services.url.update(inputValue, []);
    } else {
      this.flux.reset(inputValue)
        .then(() => this.services.tracker.search());
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/tags/submit/gb-submit.ts
 **/